import { createBrowserRouter } from 'react-router';

import { AdminShell } from './components/AdminShell.jsx';
import { RequireClient, RequireStaff } from './components/guards.jsx';
import { Shell } from './components/Shell.jsx';
import { adminRoutes, clientRoutes, publicRoutes } from './modules.js';
import { AdminDashboard } from './pages/Dashboards.jsx';
import { Home } from './pages/Home.jsx';
import { NotFound } from './pages/NotFound.jsx';
import { Loading } from './components/ui.jsx';

/**
 * Storefront, client area and admin area in one app. Routes come from the feature modules
 * (web/src/modules.js); this file only arranges them. A module route marked `bare: true` renders
 * without the shell (login pages).
 */
const bare = (routes) => routes.filter((r) => r.bare);
const framed = (routes) => routes.filter((r) => !r.bare);

// Shown while the first page's lazy chunk loads (routes are code-split per module).
const fallback = { hydrateFallbackElement: <Loading /> };

export function buildRoutes() {
  const pub = publicRoutes();
  const client = clientRoutes();
  const admin = adminRoutes();
  return [
    ...bare(pub).map((r) => ({ ...fallback, ...r })),
    ...bare(admin).map((r) => ({ ...fallback, ...r, path: `admin/${r.path}` })),
    {
      ...fallback,
      element: <Shell />,
      children: [
        ...framed(pub),
        // A signed-in client's dashboard, else the home page (or the store: pages/Home.jsx).
        { index: true, element: <Home /> },
        { element: <RequireClient />, children: framed(client) },
        { path: '*', element: <NotFound /> },
      ],
    },
    {
      ...fallback,
      path: 'admin',
      element: <RequireStaff />,
      children: [
        {
          element: <AdminShell />,
          children: [
            { index: true, element: <AdminDashboard /> },
            ...framed(admin),
            { path: '*', element: <NotFound /> },
          ],
        },
      ],
    },
  ];
}

export const router = createBrowserRouter(buildRoutes());
